
export default {
  data() {
    return {
      isCalendlyActive: false,
      isDesktop: false,
      titleArgument: `Le site web qui <br class="hidden lg:block"> vous rendra <span class="font-clash font-bold text-purple-brand">fier</span>`,
      surtitle: "Création de site web optimisé pour la navigation",
      webArguments: [
        {
          title: "Un site professionnel",
          text: "Présentez votre activité avec un site 100 % personnalisé adapté à vos besoins.",
          img: require("~/assets/img/picto-pc.svg"),
        },
        {
          title: "Une équipe d’experts",
          text: "Bénéficiez du savoir-faire de toute une équipe d'experts.",
          img: require("~/assets/img/picto-medal.svg"),
        },
        {
          title: "Des offres flexibles",
          text: "Restez maître de votre budget avec nos offres flexibles et packagées.",
          img: require("~/assets/img/picto-flex.svg"),
        },
      ],
      reviews: [
        {
          text: "Merci beaucoup à toute l'équipe qui m'accompagne avec professionnalisme à passer à une autre étape de ma communication.",
          author: "Elise haas",
        },
        {
          text: "Super agence en communication ! Création d'une page web qui correspond à ma demande et un conseiller au top. Merci ALEO !",
          author: "K.B HOME-SERVICES",
        },
        {
          text: "Je suis content de leurs services. Toujours à l'écoute et prêts à nous aider. Merci à toute l'équipe.",
          author: "Y Toitures",
        },
        {
          text: "Le travail réalisé pour le référencement est très sérieux, les équipes sont professionnelles et l'agence fait preuve d'une grande rigueur. Je recommande chaleureusement.",
          author: "Agence Alsacienne de l'Or et Numismatique",
        },
      ],
      reviewCollab: {
        author: "Mamadou - Webdesigner",
        text: "Je conçois des sites web performants et attractifs",
        img: "mamadou.png",
        alt: "Webdesigner ALEO",
      },
    };
  },
  head() {
    return {
      title: "Création Site Internet - Dès 69 € / mois | Agence ALEO",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "Confiez la création de votre site internet à l’agence ALEO et boostez votre notoriété avec un site vitrine pro visible par vos clients sur Google.",
        },
        {
          hid: "og:title",
          property: "og:title",
          content: "CRÉATION DE SITES INTERNET & RÉFÉRENCEMENT NATUREL",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "Confiez la création de votre site internet à l’agence ALEO et boostez votre notoriété avec un site vitrine pro visible par vos clients sur Google.",
        },
        // {
        //   hid: "og:image",
        //   property: "og:image",
        //   content: require("~/assets/img/og/og-facebook-sw.jpg"),
        // },
      ],
      link: [
        {
          rel: "canonical",
          href: "https://www.aleo.agency/creation-site-internet/",
        },
      ],
    };
  },

  mounted() {
    this.watchMedia();
    this.playVideo();
  },

  methods: {
    watchMedia() {
      window.matchMedia("(min-width: 1024px)").matches
        ? (this.isDesktop = true)
        : (this.isDesktop = false);

      if (this.isDesktop) {
        this.$refs.video.setAttribute("poster", "/image/thumb-video-web.jpg");
      } else {
        this.$refs.video.setAttribute(
          "poster",
          "/image/thumb-video-web-mobile.jpg"
        );
      }
    },

    playVideo() {
      const io = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            if (this.isDesktop) {
              entry.target.src = require("~/assets/video/video-aleo-web.mp4");
            } else {
              entry.target.src = require("~/assets/video/video-aleo-web-mobile.mp4");
            }
            entry.target.play();
            io.unobserve(entry.target);
          }
        });
      });

      io.observe(this.$refs.video);
    },

    activeCalendly() {
      this.isCalendlyActive = false;
      this.$nextTick(() => {
        this.isCalendlyActive = true;
      });
    },
  },
};
